import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { MainColors } from '../../../../constants/Colors';
import FontSizes from '../../../../constants/FontSizes';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const BallotItemsListListControl = (props) => {
    return (
        <View style={styles.container}>
            <Text style={styles.label}>
                Ballot Items
            </Text>

            {props.listData.length > 0 ? (
                props.listData.map((item, ballotItemIndex) => {
                    return (
                        <View key={item.ballotItemId} style={styles.listItemContainer}>
                            <Text style={styles.number}>{ballotItemIndex + 1}.</Text>
                            <Text style={styles.ballotItemTitle}>{item.ballotItemTitle}</Text>
                            <View style={{ alignSelf: 'flex-start' }}>
                                <TouchableOpacity
                                    onPress={() => props.onEditItemPressed(item, ballotItemIndex)}>
                                    <MaterialCommunityIcons name="square-edit-outline" size={20}
                                        color={MainColors.primary} />
                                </TouchableOpacity>
                            </View>
                        </View>
                    )
                })) : (
                    <View style={styles.noItemsContainer}>
                        <Text style={styles.noBallotItemsMessage}>{props.noBallotItemsMessage}</Text>
                    </View>
                )}

            <TouchableOpacity style={styles.addBallotItemButton} onPress={props.onNextButtonPress}
                disabled={props.addBallotItemButtonDisabled}>
                <Text style={props.addBallotItemButtonDisabled ? styles.disabledAddBallotItemLabel : styles.addBallotItemLabel}>Add Ballot Item</Text>
                <MaterialCommunityIcons
                    name='arrow-right-circle-outline'
                    size={20}
                    color={props.addBallotItemButtonDisabled ? MainColors.lightGray : MainColors.primary}
                />
            </TouchableOpacity>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        marginBottom: 20,
        paddingBottom: 10,
        borderBottomColor: MainColors.lightGray,
        borderBottomWidth: 1
    },
    label: {
        fontSize: FontSizes.medium,
        marginBottom: 12,
        paddingLeft: 12,
        color: MainColors.mediumGray,
        fontWeight: '500'
    },
    listItemContainer: {
        flexDirection: 'row',
        marginLeft: 12,
        alignItems: 'center',
        marginBottom: 10,
    },
    noItemsContainer: {
        flexDirection: 'row',
        marginLeft: 12,
        alignItems: 'center',
    },
    number: {
        fontWeight: '500',
        fontSize: FontSizes.medium,
        marginRight: 5,
        color: MainColors.mediumGray,
        alignSelf: 'flex-start'
    },
    ballotItemTitle: {
        flex: 1,
        flexWrap: 'wrap',
        fontWeight: '500',
        fontSize: FontSizes.medium,
        marginRight: 10,
        flexWrap: 'wrap',
        color: MainColors.darkGray,
    },
    noBallotItemsMessage: {
        fontSize: FontSizes.medium,
        color: MainColors.mediumGray,
    },
    addBallotItemButton: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    addBallotItemLabel: {
        fontSize: FontSizes.medium,
        paddingRight: 5,
        color: MainColors.primary,
        fontWeight: '500'
    },
    disabledAddBallotItemLabel: {
        fontSize: FontSizes.medium,
        paddingRight: 5,
        color: MainColors.lightGray,
        fontWeight: '500'
    }
});

export default BallotItemsListListControl;